<template>
  <div class="pagebox">
    <div>{{title}}</div>
    <div>
    <button @click="value=value-1" :disabled="value<=0"><svg width="35" height="35" viewBox="0 0 35 35" :fill="color||'var(--color-checked)'" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 35C7.83485 35 0 27.1651 0 17.5C0 7.83485 7.83485 0 17.5 0C27.1651 0 35 7.83485 35 17.5C34.9892 27.1607 27.1607 34.9892 17.5 35ZM17.5 2.82279C11.5637 2.82279 6.21131 6.3989 3.94002 11.8834C1.66823 17.3679 2.92395 23.6814 7.12179 27.8787C11.3196 32.0765 17.6326 33.3323 23.1171 31.0605C28.6016 28.7887 32.1777 23.4368 32.1777 17.5C32.1684 9.3975 25.6025 2.83163 17.5 2.82279ZM24.9798 18.9114H10.0202C9.24084 18.9114 8.60881 18.2794 8.60881 17.5C8.60881 16.7206 9.24084 16.0886 10.0202 16.0886H24.9798C25.4881 16.0827 25.9605 16.3504 26.2164 16.7894C26.4722 17.2284 26.4722 17.7711 26.2164 18.2101C25.9605 18.6496 25.4881 18.9173 24.9798 18.9114Z" :fill="color||'var(--color-checked)'"/>
    </svg>
    </button>
    <div class="page" :style="{color: color||'var(--color-checked)',border: `1px solid ${color||'var(--color-checked)'}`}">{{value}}</div>
    <button @click="value=value+1" :disabled="max?value>=max:false"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.4997 35C7.83497 35 0 27.1645 0 17.4997C0 7.83548 7.83497 0 17.4997 0C27.1645 0 35 7.83548 35 17.4997C35 27.1645 27.1645 35 17.4997 35ZM17.4997 32.3745C25.7151 32.3745 32.3745 25.7151 32.3745 17.4997C32.3745 9.28435 25.7151 2.62499 17.4997 2.62499C9.28435 2.62499 2.62499 9.28435 2.62499 17.4997C2.62499 25.7151 9.28435 32.3745 17.4997 32.3745ZM18.8122 16.1873H24.0622C24.7872 16.1873 25.3747 16.7748 25.3747 17.4997C25.3747 18.2247 24.7872 18.8122 24.0622 18.8122H18.8122V24.0622C18.8122 24.7872 18.2247 25.3747 17.4997 25.3747C16.7748 25.3747 16.1873 24.7872 16.1873 24.0622V18.8122H10.9373C10.2123 18.8122 9.62478 18.2247 9.62478 17.4997C9.62478 16.7748 10.2123 16.1873 10.9373 16.1873H16.1873V10.9373C16.1873 10.2123 16.7748 9.62478 17.4997 9.62478C18.2247 9.62478 18.8122 10.2123 18.8122 10.9373V16.1873Z" :fill="color||'var(--color-checked)'"/>
    </svg>
    </button>
</div>
  </div>
</template>

<script>
export default {
  props: ['max', 'defaultValue', 'color', 'title'],
  data () {
    return {
      value: 1
    }
  },
  mounted () {
    this.value = this.defaultValue || 0
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      if (this.defaultValue !== this.value) {
        this.$emit('input', this.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  width: 35px;
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
}
.page {
  width: 120px;
  height: 68px;
  border: 1.5px solid var(--color-base1);
  border-radius: 5px;
  font-weight: 900;
  font-size: 42px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #6D6D6D;
}
.pagebox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  &>div:nth-child(1) {
    font-weight: 500;
    font-size: 20px;
    height: 36px;
  }
  &>div:nth-child(2) {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
  }
}
</style>
